import { CheckCircle2, AlertCircle, Info } from 'lucide-react';
import { useToastStore, type ToastTone } from './toastStore';
import { cn } from '@/core/lib/cn';

const TONE_ICON = {
  success: CheckCircle2,
  error: AlertCircle,
  info: Info,
} as const;

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  return (
    <div className="fixed bottom-4 right-4 z-[60] flex w-80 flex-col gap-2">
      {toasts.map((t) => {
        const Icon = TONE_ICON[t.tone as ToastTone] ?? Info;
        return (
          <div
            key={t.id}
            onClick={() => dismiss(t.id)}
            role="status"
            className={cn(
              'flex cursor-pointer items-start gap-2 rounded-lg px-4 py-3 text-sm font-medium text-white shadow-lg',
              t.tone === 'success' ? 'bg-fv-primary' : t.tone === 'error' ? 'bg-fv-error' : 'bg-fv-ink',
            )}
          >
            <Icon size={16} className="mt-0.5 shrink-0" />
            <span className="min-w-0">{t.message}</span>
          </div>
        );
      })}
    </div>
  );
}
